/**
 * Turning a document's deliverables into a template's stages.
 *
 * A Terms of Reference writes its deliverables as instructions with the deadline inside them —
 * "By 31 Aug 2026, submit a validated database containing procurement volumes for ARVs…". Saved
 * as a stage verbatim, the template carries one project's dates into the next, and the screen's
 * promise that a template holds no dates is simply untrue.
 *
 * So the date is taken off the front, and what is left is the stage: "Submit a validated
 * database containing…".
 *
 * WHAT THIS DOES NOT DO. It cannot make a stage generic. "ARVs and AHD medicines reported
 * through GAM 2026" is what that client's work IS, and a template taken from their document is
 * meant to look like their work — that is the point of taking it from their document. Stages
 * stay editable afterwards for anyone who wants them shorter.
 */

// "By 31 Aug 2026," · "By 31 August 2026:" · "By end of Q1 2027 -" · "Before 15/03/2026,"
// Anchored to the start and requiring a year, so a sentence that merely mentions a month is
// left alone.
const LEADING_DEADLINE = /^\s*(by|before|no later than|due(?:\s+by)?)\b[^,:.–—-]*\b(19|20)\d{2}\b\s*[,:.–—-]*\s*/i

export function stageTitleFrom(raw) {
  let t = String(raw || '').trim()
  if (!t) return ''
  const stripped = t.replace(LEADING_DEADLINE, '')
  // Only if something is left. A deliverable that is nothing BUT a date keeps its original
  // wording rather than becoming an empty stage.
  if (stripped.trim().length >= 3) t = stripped.trim()
  // A sentence reads oddly as a stage name when it starts lower-case after the date came off.
  return t.charAt(0).toUpperCase() + t.slice(1)
}

/** The stages a template keeps, from a parsed document's deliverables. */
export function stagesFromDeliverables(deliverables) {
  return (deliverables || [])
    .map(d => stageTitleFrom(typeof d === 'string' ? d : (d?.title || d?.description || '')))
    .filter(Boolean)
    .map(title => ({ title, payment_mode: 'Fixed' }))
}
